import styled from 'styled-components';
import { motion } from 'framer-motion';

export const InfoSec = styled.section`
  color: #0f1115;
  padding: 110px 0;
  z-index: 10;
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 85% 0%, ${(props) => props.theme.text}0f 0%, transparent 45%),
    #f6f7f9;

  @media screen and (max-width: 768px) {
    padding: 80px 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    padding: 0 26px;
  }
`;

export const Title = styled(motion.h2)`
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(props) => props.theme.text};
  margin-bottom: 10px;
`;

export const Heading = styled(motion.h1)`
  text-align: center;
  font-size: 42px;
  font-weight: 700;
  color: #0f1115;
  margin-bottom: 56px;
  font-family: 'Poppins', sans-serif;

  @media screen and (max-width: 768px) {
    font-size: 30px;
    margin-bottom: 40px;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 64px;
  flex-direction: ${({ imgStart }) => (imgStart ? 'row-reverse' : 'row')};

  @media screen and (max-width: 900px) {
    flex-direction: column;
    gap: 44px;
  }
`;

export const InfoColumn = styled.div`
  flex: 1;
  min-width: 280px;
  display: flex;
  justify-content: center;
`;

export const TextWrapper = styled.div`
  max-width: 600px;
`;

export const Subtitle = styled(motion.p)`
  font-size: 18px;
  line-height: 1.8;
  color: #424a57;
  margin-bottom: 34px;

  @media screen and (max-width: 600px) {
    font-size: 16px;
  }
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media screen and (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const StatCard = styled(motion.div)`
  padding: 22px 24px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid #e6e8ec;
  box-shadow: 0 12px 30px -22px rgba(15, 17, 21, 0.5);
  transition: transform 0.25s ease, border-color 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: ${(props) => props.theme.text};
  }

  strong {
    display: block;
    font-size: 30px;
    font-weight: 800;
    color: ${(props) => props.theme.text};
    line-height: 1;
  }
  span {
    display: block;
    margin-top: 8px;
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
  }
`;

export const ImgWrapper = styled(motion.div)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImgRing = styled.div`
  position: relative;
  width: 380px;
  height: 380px;
  border-radius: 30px;
  padding: 10px;
  background: linear-gradient(135deg, ${(props) => props.theme.text}, transparent 60%);

  @media screen and (max-width: 570px) {
    width: 290px;
    height: 290px;
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 22px;
  display: block;
`;

export const Blob = styled.div`
  position: absolute;
  inset: -30px;
  border-radius: 50%;
  background: radial-gradient(circle, ${(props) => props.theme.text}30 0%, transparent 65%);
  filter: blur(40px);
  z-index: -1;
`;
